import { render } from "./activityManagement.vue?vue&type=template&id=74bf13ee"
import script from "./activityManagement.vue?vue&type=script&lang=js"
export * from "./activityManagement.vue?vue&type=script&lang=js"

import "./activityManagement.vue?vue&type=style&index=0&id=74bf13ee&lang=less"
script.render = render

export default script